module.exports = __webpack_public_path__ + "img/HomePage-universities.3269945.webp";